import { ProtocolIcon } from './chunk-7K5EYODF.js';
import { POLYMARKET_CTF_EXCHANGE, POLYMARKET_EVENTS, POLYMARKET_COMPONENTS, pickField, POLYMARKET_FIELDS, polymarketSide, POLYMARKET_SIDE_VERBS, polymarketPrice, POLYMARKET_LABELS, ProtocolValue, SectionCard, FactGrid, ProtocolParamList, ProtocolBadge } from './chunk-XH4WXZPE.js';
import { CandlestickChart } from 'lucide-react';
import { jsx, jsxs } from 'react/jsx-runtime';

function PolymarketOrderFill({
  event: event2,
  hint,
  chain,
  renderAddress
}) {
  const pid = hint.protocolId ?? POLYMARKET_CTF_EXCHANGE.protocolId;
  const maker = pickField(event2.params, POLYMARKET_FIELDS.maker, POLYMARKET_FIELDS.takerOrderMaker);
  const taker = pickField(event2.params, POLYMARKET_FIELDS.taker);
  const orderHash = pickField(event2.params, POLYMARKET_FIELDS.orderHash, POLYMARKET_FIELDS.takerOrderHash);
  const outcome = pickField(event2.params, POLYMARKET_FIELDS.tokenId, POLYMARKET_FIELDS.makerAssetId, POLYMARKET_FIELDS.takerAssetId);
  const makerAmount = pickField(event2.params, POLYMARKET_FIELDS.makerAmountFilled);
  const takerAmount = pickField(event2.params, POLYMARKET_FIELDS.takerAmountFilled);
  const fee = pickField(event2.params, POLYMARKET_FIELDS.fee);
  const market = pickField(event2.params, POLYMARKET_FIELDS.conditionId);
  const side = polymarketSide(pickField(event2.params, POLYMARKET_FIELDS.side));
  const verb = side ? POLYMARKET_SIDE_VERBS[side] : void 0;
  const price = polymarketPrice(side, makerAmount, takerAmount);
  const address = (v) => typeof v === "string" && renderAddress ? renderAddress(v, { chain }) : /* @__PURE__ */ jsx(ProtocolValue, { value: v });
  const facts = [
    { label: POLYMARKET_LABELS.market, value: /* @__PURE__ */ jsx(ProtocolValue, { value: market }), when: market },
    { label: POLYMARKET_LABELS.trader, value: address(maker), when: maker },
    { label: POLYMARKET_LABELS.counterparty, value: address(taker), when: taker },
    { label: POLYMARKET_LABELS.outcome, value: /* @__PURE__ */ jsx(ProtocolValue, { value: outcome }), when: outcome },
    { label: POLYMARKET_LABELS.price, value: /* @__PURE__ */ jsx(ProtocolValue, { value: price }), when: price != null },
    {
      label: verb?.makerGave ?? POLYMARKET_LABELS.paid,
      value: /* @__PURE__ */ jsx(ProtocolValue, { value: makerAmount }),
      when: makerAmount != null
    },
    {
      label: verb?.makerGot ?? POLYMARKET_LABELS.received,
      value: /* @__PURE__ */ jsx(ProtocolValue, { value: takerAmount }),
      when: takerAmount != null
    },
    { label: POLYMARKET_LABELS.order, value: /* @__PURE__ */ jsx(ProtocolValue, { value: orderHash }), when: orderHash },
    { label: POLYMARKET_LABELS.fee, value: /* @__PURE__ */ jsx(ProtocolValue, { value: fee }), when: fee != null && String(fee) !== "0" }
  ];
  return /* @__PURE__ */ jsxs(
    SectionCard,
    {
      title: /* @__PURE__ */ jsxs("span", { className: "inline-flex items-center gap-2", children: [
        /* @__PURE__ */ jsx(ProtocolIcon, { protocolId: pid, icon: CandlestickChart }),
        /* @__PURE__ */ jsx("span", { className: "text-sm font-semibold", children: hint.label ?? verb?.title ?? event2.name ?? "Prediction-market trade" })
      ] }),
      protocolId: pid,
      meta: /* @__PURE__ */ jsx(ProtocolBadge, { protocolId: pid }),
      children: [
        /* @__PURE__ */ jsx(FactGrid, { facts }),
        /* @__PURE__ */ jsxs("details", { className: "mt-3 min-w-0", children: [
          /* @__PURE__ */ jsx("summary", { className: "cursor-pointer text-xs text-muted-foreground hover:text-foreground", children: "All event fields" }),
          /* @__PURE__ */ jsx("div", { className: "pt-2", children: /* @__PURE__ */ jsx(ProtocolParamList, { params: event2.params, emptyLabel: "No decoded fields" }) })
        ] })
      ]
    }
  );
}

// src/protocols/polymarket_ctf_exchange/index.ts
var PID = POLYMARKET_CTF_EXCHANGE.protocolId;
var C = POLYMARKET_COMPONENTS;
var event = (name) => ({
  protocolId: PID,
  event: name,
  component: C.fill,
  summaryFields: []
});
var POLYMARKET_CTF_EXCHANGE_HINTS = {
  valueHints: [],
  callHints: [],
  eventHints: [
    event(POLYMARKET_EVENTS.orderFilled),
    event(POLYMARKET_EVENTS.ordersMatched)
  ]
};
function registerPolymarketCtfExchange(registry) {
  registry.registerEvent(C.fill, PolymarketOrderFill);
  registry.registerHints(POLYMARKET_CTF_EXCHANGE_HINTS);
  return registry;
}

export { POLYMARKET_CTF_EXCHANGE_HINTS, PolymarketOrderFill, registerPolymarketCtfExchange };
//# sourceMappingURL=chunk-X3CKVFJV.js.map
//# sourceMappingURL=chunk-X3CKVFJV.js.map